import styles from './servicios.module.css'
import { Link } from "react-router-dom"

export const servicios = () => {
    return (
        <div className={styles.main}>
            <div className={styles.menu}>
                <div className={styles.innermenu}>
                    <div className={styles.logo}></div>
                    
                    <div className={styles.btns}>
                        <Link to="/"><button id={styles.homebtn}>Home</button></Link>
                        <Link to="/contacto"><button id={styles.contactbtn}>Contacto</button></Link>
                    </div> 
                </div>

                <div className={styles.headerbottom}>
                    <p id={styles.message}>Despachos con normalidad</p>
                </div>
 
            </div>

                <div className={styles.servicesDiv}>

                        <div id={styles.ayv} className={styles.largebox}>Arriendo de fotocopiadoras</div>
                      
                        <div id ={styles.col2}>                      
                            <div id={styles.message1} className={styles.messagebox}>Trabajando por un buen servicio</div>
                            <div id={styles.anillado} className={styles.mediumbox}>Anillados</div>
                        </div>

                        <div id={styles.col3}>
                            <div id={styles.impresiones} className={styles.smallbox}>Impresiones B&N</div>
                            <div id={styles.afiches_poster} className={styles.mediumbox}>Impresion de afiches y poster</div>
                        </div>

                        <div id={styles.col4}>
                            <div id={styles.foto} className={styles.mediumbox}>Impresion de fotografias</div>
                            <div id={styles.message2} className={styles.messagebox}>Comprometidos con una buena entrega</div>
                        </div>
                       
                        <div id={styles.planos} className={styles.largebox}>Ploteo de planos</div>
                </div>
           
        </div> 
    )
}
